import { create } from 'zustand';

/** A post announced by `feed.post-created` that the reader has not loaded yet. */
export interface PendingPost {
  postId: string;
  groupIds: string[];
}

interface NewPostsState {
  pending: PendingPost[];
  add: (post: PendingPost) => void;
  /** Forget the announced posts (all, or those of one group's feed). */
  clear: (groupId?: string | null) => void;
  reset: () => void;
}

const MAX_PENDING = 200;

/** Posts other people published while the reader is looking at the feed ("N new posts" indicator). */
export const useNewPostsStore = create<NewPostsState>()((set) => ({
  pending: [],
  add: (post) =>
    set((state) =>
      state.pending.some((p) => p.postId === post.postId)
        ? state
        : { pending: [post, ...state.pending].slice(0, MAX_PENDING) },
    ),
  clear: (groupId) =>
    set((state) => ({
      pending: groupId ? state.pending.filter((p) => !p.groupIds.includes(groupId)) : [],
    })),
  reset: () => set({ pending: [] }),
}));

/** Number of announced posts for the main feed or one group's feed. */
export function countPending(pending: readonly PendingPost[], groupId?: string | null): number {
  return groupId ? pending.filter((p) => p.groupIds.includes(groupId)).length : pending.length;
}
